module.exports = __webpack_public_path__ + "static/media/abouttitlear.7b1d05fa.png";